<template>
  <div>
    <!-- 新增、编辑合同 -->
    <el-dialog
      :visible.sync="isCf"
      width="40%"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :before-close="handleClose2"
    >
      <div style="font-size: 30px">{{ cfInfo.electricity }}</div>
      <div style="font-size: 30px">{{ cfInfo.water }}</div>
      <div style="font-size: 30px">{{ cfInfo.wuYePay }}</div>
      <div style="font-size: 30px">{{ cfInfo.summary }}</div>
      <span class="dialog-footer">
        <el-button @click="handleClose2">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :before-close="handleClose"
    >
      <el-form :model="formData" ref="formData" :rules="rules" label-width="110px">
        <el-form-item prop="names" label="退房申请单">
          <el-autocomplete
            style="width: 100%"
            :disabled="isShow"
            v-model="formData.names"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入人才姓名"
            value-key="opinion"
            clearable
            @clear="clearSearch"
            @select="handleSelect"
            ref="myAutocomplete"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item prop="company" label="所属单位">
          <el-input style="width: 100%" v-model="formData.company" disabled=""></el-input>
        </el-form-item>
        <div style="display: flex; justify-content: space-between">
          <el-form-item prop="name" label="人才">
            <el-input disabled="" v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item prop="roomNum" label="房间号">
            <el-input disabled="" v-model="formData.roomNum"></el-input>
          </el-form-item>
        </div>

        <el-form-item prop="time" label="退房时间">
          <el-date-picker
            :disabled="isShow"
            type="datetime"
            placeholder="选择退房时间"
            v-model="formData.time"
            style="width: 100%"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="checkList" label="">
          <el-checkbox
            @change="disputeChange"
            v-model="formData.dispute"
            :disabled="isShow && !process"
            label="存在未结事项"
          ></el-checkbox>
        </el-form-item>
        <el-form-item v-if="formData.dispute" prop="describes" label="未结事项描述">
          <el-input
            type="textarea"
            v-model="formData.describes"
            placeholder="请输入未结事项描述"
          ></el-input>
        </el-form-item>
        <el-form-item prop="fileName" label="附件">
          <el-upload
            :limit="1"
            action="/api/admin/roomManage/uploadRoomFile"
            :on-remove="removeFile"
            :file-list="fileList"
            name="file"
            :on-preview="uploadDown"
            :headers="headers"
            :on-success="uploadSuccess"
          >
            <el-button :disabled="isShow" size="small" type="primary"
              >点击上传文件</el-button
            >
          </el-upload>
        </el-form-item>

        <div v-if="isShow">
          <div style="display: flex; justify-content: space-between">
            <el-form-item prop="createName" label="创建人">
              <el-input v-model="formData.createName" disabled=""></el-input>
            </el-form-item>
            <el-form-item prop="createTime" label="创建时间">
              <el-input v-model="formData.createTime" disabled=""></el-input>
            </el-form-item>
          </div>
        </div>
        <div v-if="process">
          <div style="display: flex; justify-content: space-between">
            <el-form-item prop="canBeCleaned" label="保洁确认状态：">
              <span>{{ formData.canBeCleaned == 1 ? "已确认" : "未确认" }}</span>
              <!-- <el-input v-model="formData.cleanStatus" disabled=""></el-input> -->
            </el-form-item>
            <!-- <el-form-item prop="cleanName" label="确认人：">
							<el-input v-model="formData.cleanName" disabled=""></el-input>
						</el-form-item> -->
          </div>
          <div style="display: flex; justify-content: space-between">
            <el-form-item prop="isEquipOk" label="工程确认状态：">
              <span>{{ formData.isEquipOk == 1 ? "已确认" : "未确认" }}</span>
              <!-- <el-input v-model="formData.engineeringStatus" disabled=""></el-input> -->
            </el-form-item>
            <!-- <el-form-item prop="engineeringName" label="确认人：">
							<el-input v-model="formData.engineeringName" disabled=""></el-input>
						</el-form-item> -->
          </div>
        </div>
      </el-form>
      <span v-if="!isShow && !process" slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">取 消</el-button>
        <el-button type="primary" @click="confirmClick">确 定</el-button>
      </span>
      <span v-if="isShow && process" slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">取 消</el-button>
        <el-button type="primary" @click="processClick">审 核</el-button>
      </span>
      <span v-if="isShow && !process" slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">取 消</el-button>
        <!-- <el-button type="primary" @click="confirmClick">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import downloadFile from "../../../assets/js/downloadFile.js";
export default {
  props: ["title", "dialogVisible", "obj"],
  watch: {
    title: function (val) {
      console.log(val);
      if (val == "新增退房") {
        this.formData = {
          ...this.oldFormData,
        };
        this.fileList = [];
        this.isShow = false;
        this.process = false;
      } else if (val == "查看退房") {
        this.formData = {
          ...this.obj,
        };

        this.formData.names = this.formData.name;
        if (this.formData.dispute == "是") {
          this.formData.dispute = true;
        } else {
          this.formData.dispute = false;
        }
        // this.formData.roomNumber = this.formData.roomNumber
        // this.formData.filePath=this.formData.showPath
        // if (this.formData.fileRes != null) {
        let newFiles = [];
        newFiles.push({
          name: this.formData.fileName,
          url: this.formData.filePath,
        });
        this.fileList = newFiles;
        console.log(this.fileList);
        // this.fileList[0] = this.formData.showPath;
        // }
        this.isShow = true;
        this.process = false;
      } else if (val == "确认退房") {
        this.formData = {
          ...this.obj,
        };

        this.formData.names = this.formData.name;
        if (this.formData.dispute == "是") {
          this.formData.dispute = true;
        } else {
          this.formData.dispute = false;
        }
        // scope.row.canBeCleaned == 1 && scope.row.isEquipOk == 1
        // this.formData.roomNumber = this.formData.roomNumber
        // this.formData.filePath=this.formData.showPath
        // if (this.formData.fileRes != null) {
        let newFiles = [];
        newFiles.push({
          name: this.formData.fileName,
          url: this.formData.filePath,
        });
        this.fileList = newFiles;
        console.log(this.fileList);
        // this.fileList[0] = this.formData.showPath;
        // }
        this.isShow = true;
        this.process = true;
      }
    },
  },
  data() {
    return {
      headers: {
        Authorization: localStorage.access_token,
      },
      isCf: false,
      process: false,
      cfInfo: {},
      isShow: null,
      disabled: false,
      fileList: [],
      options: [],
      oldFormData: "", //初始数据备份
      formData: {
        names: "",
        company: null,
        name: null,
        roomNum: null,
        roomNumber: null,
        time: null,
        dispute: false,
        describes: null,
        filePath: null,
        fileName: null,
        checkInId: null,
        userId: null,
      },
      rules: {
        time: [
          {
            required: true,
            message: "登记日期不能为空",
            trigger: ["blur", "change"],
          },
        ],
        endTime: [
          {
            required: true,
            message: "截止日期不能为空",
            trigger: ["blur", "change"],
          },
        ],
        names: [
          {
            required: true,
            message: "入住申请单不能为空",
            trigger: ["blur", "change"],
          },
        ],
        roomNum: [
          {
            required: true,
            message: "房间号不能为空",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "人才姓名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        company: [
          {
            required: true,
            message: "所属单位不能为空",
            trigger: ["blur", "change"],
          },
        ],
        fileName: [
          {
            required: true,
            message: "附件不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      restaurants: [],
      state: "",
      timeout: null,
    };
  },
  methods: {
    disputeChange() {
      if (this.formData.dispute) {
      } else {
        this.formData.describes = "";
      }
    },
    handleClose2() {
      this.isCf = false;
    },
    getRoomTree(company) {
      let newRoomTree = [];
      this.$http.get("/api/roomManage/getRoomTree?company=" + company).then((res) => {
        console.log(res);
        res.data.data.forEach((item1, index1) => {
          newRoomTree.push({
            value: item1.building,
            label: item1.building,
            children: [],
          });
          item1.getStoreyRoomResList.forEach((item2, index2) => {
            newRoomTree[index1].children.push({
              value: item2.storey,
              label: item2.storey,
              children: [],
            });
            item2.getRoomResList.forEach((item3, index3) => {
              newRoomTree[index1].children[index2].children.push({
                value: item3.id,
                label: item3.roomNumber,
              });
            });
          });
        });
        this.options = newRoomTree;
      });
    },
    handleSelect(item) {
      this.formData.company = item.company;
      this.formData.userId = item.userId;
      this.formData.checkInId = item.id;
      this.formData.roomNum = item.roomNum;
      this.formData.roomNumber = item.roomNumber;
      this.formData.name = item.name;
      console.log("退房申请单选中项：", JSON.stringify(item));
    },
    tableParValueChange(value, currency, decimals) {
      const digitsRE = /(\d{3})(?=\d)/g;
      value = parseFloat(value);
      if (!isFinite(value) || (!value && value !== 0)) return "";
      currency = currency != null ? currency : "$";
      decimals = decimals != null ? decimals : 2;
      var stringified = Math.abs(value).toFixed(decimals);
      var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
      var i = _int.length % 3;
      var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? "," : "") : "";
      var _float = decimals ? stringified.slice(-1 - decimals) : "";
      var sign = value < 0 ? "-" : "";
      this.formData.money =
        sign + currency + head + _int.slice(i).replace(digitsRE, "$1,") + _float;
    },

    uploadDown(obj) {
      console.log(obj);
      this.$confirm("确定下载该文件吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          downloadFile(obj);
          this.$message({
            type: "success",
            message: "下载成功!",
          });
        })
        .catch((err) => {
          this.$message({
            type: "success",
            message: "取消下载!",
          });
        });
    },
    querySearchAsync(queryString, cb) {
      if (this.formData.name == undefined) {
        this.formData.name = "";
      }
      console.log("formData:", JSON.stringify(this.formData));
      this.$http
        .get(
          `/api/bdCheckOutRegister/getCheckInRegisterByStatus?name=${this.formData.names}`
        )
        .then((res) => {
          console.log("查询所有入住中的信息：", JSON.stringify(res.data));
          res.data.data.forEach((val) => {
            console.log(val.createTime);
            var a = val.createTime.split("T")[0];
            var b = a.split("T")[0];
            val.opinion = val.company + "-" + val.name + "-" + b;
          });

          let result = res.data.data;
          cb(result);
        });
    },
    clearSearch() {
      this.$refs.myAutocomplete.handleFocus();
    },
    removeFile(file, fileList) {
      this.formData.filePath = "";
      this.formData.fileName = "";
    },
    //上传附件
    detailFileList(fileList) {
      console.log(fileList);
      // fileList.forEach((item) => {
      // 	if (item.hasOwnProperty('response')) {
      // 		newFiles.push({
      // 			name: item.name,
      // 			url: item.response.data
      // 		})
      // 	} else {
      // 		newFiles.push({
      // 			name: item.name,
      // 			url: item.url
      // 		});
      // 	}
      // })
      this.formData.filePath = fileList[0].response.data.filePath;
      this.formData.fileName = fileList[0].response.data.fileName;
    },
    uploadSuccess(response, file, fileList) {
      this.detailFileList(fileList);
    },
    // 取消
    cancelClick() {
      this.close();
    },
    // 确定
    confirmClick() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          // this.$http.get(`/api/checkInApply/isWuYeWaterElectricity?userId=${this.formData.userId}`).then(res=>{
          // 	console.log(res)
          // 	if(res.data.data.flag==true){
          // 		this.isCf=true
          // 		this.cfInfo=res.data.data
          // 		return
          // 	}else{
          // 		this.$emit("addSubmit", this.formData)
          // 	}
          // })
          this.$emit("addSubmit", this.formData);
          // this.formData.name = this.formData.names
        } else {
          return;
        }
      });
    },
    processClick() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          let url = "/api/bdCheckOutRegister/confirmCheckOutRegister";
          let params = this.formData;
          params.checkOutRegisterId = this.formData.id;
          params.confirmType = "kefu";
          this.$http
            .post(url, params)
            .then((res1) => {
              if (res1.data.code == 0) {
                this.$http
                  .post("/api/bdCheckOutRegister/confirmCheckOutRegisterNew", params)
                  .then((res) => {
                    this.$message.success(res1.data.message);
                    this.$parent.addClose();
                    this.$parent.getAll();
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else {
                this.$message.error(res1.data.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          return;
        }
      });
    },
    // 关闭之前的回调
    handleClose(done) {
      this.close();
    },
    // 关闭模态框向父组件传dialogVisible
    close() {
      this.$parent.addClose();
    },
  },
  created() {
    this.oldFormData = JSON.parse(JSON.stringify(this.formData));
    this.getRoomTree("");
  },
};
</script>

<style scoped="scoped"></style>
